import { useQuery } from '@tanstack/react-query';
import {getVideoHistory} from '@/api/videos';
import { queryKeys } from '@/lib/queryKeys';

export function useVideoHistoryQuery(enabled: boolean = true) {
  return useQuery({
    queryKey: queryKeys.videos.history(),
    queryFn: () => getVideoHistory(),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}